var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M3.05835 2.08301V12.058C3.05835 12.8747 3.44168 13.6497 4.10002 14.1413L8.44168 17.3913C9.36668 18.083 10.6417 18.083 11.5667 17.3913L15.9083 14.1413C16.5667 13.6497 16.95 12.8747 16.95 12.058V2.08301H3.05835Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 2.70801H1.66663C1.32496 2.70801 1.04163 2.42467 1.04163 2.08301C1.04163 1.74134 1.32496 1.45801 1.66663 1.45801H18.3333C18.675 1.45801 18.9583 1.74134 18.9583 2.08301C18.9583 2.42467 18.675 2.70801 18.3333 2.70801Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 7.29199H6.66663C6.32496 7.29199 6.04163 7.00866 6.04163 6.66699C6.04163 6.32533 6.32496 6.04199 6.66663 6.04199H13.3333C13.675 6.04199 13.9583 6.32533 13.9583 6.66699C13.9583 7.00866 13.675 7.29199 13.3333 7.29199Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.458H6.66663C6.32496 11.458 6.04163 11.1747 6.04163 10.833C6.04163 10.4913 6.32496 10.208 6.66663 10.208H13.3333C13.675 10.208 13.9583 10.4913 13.9583 10.833C13.9583 11.1747 13.675 11.458 13.3333 11.458Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote3);
export default __webpack_public_path__ + "static/media/note3.bd7762c53fbbc9ecc8d21db99606ca90.svg";
export { ForwardRef as ReactComponent };